var config = {
    api: {
        host: process.env.API_URL
    },
    widget: {
        timeSessionWdSummary: process.env.TIME_SESSION_WIDGET_SUMMARY || 900000
    },
    global: {
        globalUpdateInterval: process.env.GLOBAL_UPDATE_INTERVAL || 30000
    },
    gtm: {
        id: process.env.GTM_TAG_SCRIPT || "",
        idGeneral: process.env.GTM_TAG_GENERAL_SCRIPT || ""
    }
};
var API_HOST = config.api.host;
var TIME_SESSION_WIDGET_SUMMARY = config.widget.timeSessionWdSummary;
var GLOBAL_UPDATE_INTERVAL = config.global.globalUpdateInterval;
var GTM_ID = config.gtm.id;
var GTM_ID_GENERAL = config.gtm.idGeneral;
export { API_HOST, TIME_SESSION_WIDGET_SUMMARY, GLOBAL_UPDATE_INTERVAL, GTM_ID, GTM_ID_GENERAL };
export default config;
